import { RATING_REVIEW, DOWNLOAD_RATING_REVIEW, RATING_REVIEW_SUMMARY, DOWNLOAD_RATING_REVIEW_SUMMARY, RATING_AGGREGATION, RATING_TAGS } from '../actions/rating';

import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';

function* fetchRating(action) {
  try {
    const response = yield call(API.getRating, action.payload);
    yield put({ type: RATING_REVIEW.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: RATING_REVIEW.FAIL, payload: { error: e } });
  }
}

function* downloadRatingReview(action) {
  try {
    const response = yield call(API.downloadRating, action.payload);
    yield put({ type: DOWNLOAD_RATING_REVIEW.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DOWNLOAD_RATING_REVIEW.FAIL, payload: { error: e } });
  }
}

function* fetchRatingSummary(action) {
  try {
    const response = yield call(API.getRatingSummary, action.payload);
    yield put({ type: RATING_REVIEW_SUMMARY.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: RATING_REVIEW_SUMMARY.FAIL, payload: { error: e } });
  }
}

function* downloadRatingReviewSummary(action) {
  try {
    const response = yield call(API.downloadRatingSummary, action.payload);
    yield put({ type: DOWNLOAD_RATING_REVIEW_SUMMARY.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DOWNLOAD_RATING_REVIEW_SUMMARY.FAIL, payload: { error: e } });
  }
}

function* fetchRatingAggregation(action) {
  try {
    const response = yield call(API.getRatingAggregation, action.payload);
    yield put({ type: RATING_AGGREGATION.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: RATING_AGGREGATION.FAIL, payload: { error: e } });
    action.cb && action.cb(e?.response);
  }
}

function* fetchRatingTags(action) {
  try {
    const response = yield call(API.getRatingTags, action.payload);
    const data = response.data;
    const tags = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
    yield put({ type: RATING_TAGS.SUCCESS, payload: tags });
    action.cb && action.cb(response);

  } catch (e) {
    yield put({ type: RATING_TAGS.FAIL, payload: { error: e } });
  }
}

function* rating() {
  yield takeLatest(RATING_REVIEW.REQUEST, fetchRating);
  yield takeLatest(DOWNLOAD_RATING_REVIEW.REQUEST, downloadRatingReview);
  yield takeLatest(RATING_REVIEW_SUMMARY.REQUEST, fetchRatingSummary);
  yield takeLatest(DOWNLOAD_RATING_REVIEW_SUMMARY.REQUEST, downloadRatingReviewSummary);
  yield takeLatest(RATING_AGGREGATION.REQUEST, fetchRatingAggregation);
  yield takeLatest(RATING_TAGS.REQUEST, fetchRatingTags);
}
export default rating;
